import { CustomError } from '@components/ErrorBoundary/ErrorMessage'
import { FormattedMessage } from 'react-intl'
import { closeItemEditor, removeItem } from 'src/store/slices/dashboard'
import { useAppDispatch } from 'universal-scripts'

interface QueryNotFoundFallbackProps {
  itemId: string | null
  error?: CustomError | null
}

export default function QueryNotFoundFallback({
  itemId,
  error
}: QueryNotFoundFallbackProps) {
  const dispatch = useAppDispatch()

  const is404 = error?.status === 404

  const handleDelete = () => {
    if (itemId) {
      dispatch(removeItem(itemId))
    }
    dispatch(closeItemEditor())
  }

  const handleClose = () => dispatch(closeItemEditor())

  return (
    <aside id="item-editor-panel">
      <header className="item-editor-header">
        <h3>
          <FormattedMessage id="item-editor.chart.editor-title" />
        </h3>
        <span
          className="icon icon-cross standart-button"
          onClick={handleClose}
        />
      </header>
      <div className="item-editor-body item-editor-error-state">
        <h4>
          <FormattedMessage
            id={
              is404
                ? 'item-editor.chart.query-not-found.title'
                : 'item-editor.chart.generic-error.title'
            }
          />
        </h4>
        <p>
          <FormattedMessage
            id={
              is404
                ? 'item-editor.chart.query-not-found.description'
                : 'item-editor.chart.generic-error.description'
            }
          />
        </p>
        <div className="item-editor-error-actions">
          {itemId && is404 && (
            <button className="highlight-button danger" onClick={handleDelete}>
              <span>
                <FormattedMessage id="item-editor.chart.query-not-found.delete" />
              </span>
            </button>
          )}
        </div>
      </div>
    </aside>
  )
}
